<template>
    <div>
        <DCard
            :title="__('products.download_upload.plans.upload_form.title')"
            padding
        >
            <DFormRow
                :label="__('products.download_upload.plans.upload_form.name')"
                is-required
            >
                <DInput
                    id="price-plans-upload-name"
                    v-model="form.name"
                    required
                    :invalid-feedback="errors.name"
                />
            </DFormRow>
            <div class="file-section">
                <DFormRow
                    :label="__('products.download_upload.plans.upload_form.file')"
                    is-required
                    class="price-plans-upload-file"
                >
                    <DFileInput
                        id="price-plans-upload-file"
                        :custom="true"
                        :multiple="false"
                        :invalid-feedback="errors.file"
                        :file-with-errors="fileWithErrors"
                        :is-valid="!hasAnyErrors"
                        @change="addFile"
                        @reset-file-with-errors="resetFileWithErrors"
                    />
                </DFormRow>
            </div>
        </DCard>

        <DCard
            v-if="tableItems.length"
            :title="__('products.download_upload.plans.upload_form.excel_errors')"
            class="mt-3"
        >
            <DTable
                :items="tableItems"
                :fields="columns"
            />
        </DCard>

        <DFormControls
            :dirty="form.isDirty"
            :disabled="form.processing || !form.file"
            :submit-message="__('products.download_upload.plans.upload_form.upload')"
            submit-icon="upload"
            :cancel-route="computedCancelRoute"
            @submit="submitForm"
        />
    </div>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm, usePage } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'
import { computed, ref } from 'vue'

const props = defineProps({
    submitRoute: {
        type: String,
        required: true,
    },
    cancelRouteName: {
        type: String,
        required: true,
    },
    errors: {
        type: Object,
        default: () => ({}),
    },
})

const page = usePage()

const tableItems = computed(() => {
    const raw = page.props.errors?.importErrors
    if (!raw) return []

    return JSON.parse(raw).map(({ row, column, error }) => ({
        row: row ? `${row}` : '',
        column,
        error,
        _classes: 'table-danger',
    }))
})

const hasAnyErrors = computed(() =>
    !!page.props.errors?.importErrors || !!props.errors?.file
)

const columns = [
    { key: 'row', label: __('products.download_upload.plans.upload_form.column_row') },
    { key: 'column', label: __('products.download_upload.plans.upload_form.column_column') },
    { key: 'error', label: __('products.download_upload.plans.upload_form.column_error') },
]

const form = useForm({
    name: null,
    file: null,
})

const fileWithErrors = ref(false)

const computedCancelRoute = computed(() => route(props.cancelRouteName))

function addFile (fileList) {
    form.file = fileList[0]
}

function submitForm () {
    form.post(route(props.submitRoute), {
        onError: () => {
            form.file = null
            fileWithErrors.value = true
        },
    })
}

function resetFileWithErrors () {
    fileWithErrors.value = false
}
</script>

<style scoped lang="scss">
.price-plans-upload-file {
    margin-bottom: 5px !important;
}
.file-section {
    margin-bottom: 25px;
}
</style>
